import { Component, Input, OnInit } from '@angular/core';
import { UICollectionTypes } from '../../../entities/enums/ui-collection-types.enum';
import { IntegratedGridProtectionDocument } from '../../../entities/integratedGridProtectionDocument';
import { BaseTechnicalSectionComponent } from '../../common/base-technical-section.component';
import { EnvironmentService } from 'src/app/services/environment.service';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-power-plant-protection',
  templateUrl: './power-plant-protection.component.html',
  styleUrls: ['./power-plant-protection.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class PowerPlantProtectionComponent extends BaseTechnicalSectionComponent {
  @Input() isIntegratedGridProtection: boolean;
  @Input() isCentralGridProtection: boolean;

  @Input() documentsRequired: boolean;

  showE7AuditReportInverter = this.environmentService.showE7AuditReportInverter;

  constructor(commentService: GridApplicationCommentsService, environmentService: EnvironmentService) {
    super(commentService, environmentService);
  }

  get generatorGridProtectionDocuments(): IntegratedGridProtectionDocument[] {
    return this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.filter(
      x => x.unit_type === UICollectionTypes.Generator
    );
  }

  get inverterGridProtectionDocuments(): IntegratedGridProtectionDocument[] {
    return this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.filter(
      x => x.unit_type === UICollectionTypes.PowerInverter
    );
  }

  get converterGridProtectionDocuments(): IntegratedGridProtectionDocument[] {
    return this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.filter(
      x => x.unit_type === UICollectionTypes.PowerConverter
    );
  }

  public showPowerPlantProtectionSection(): boolean {
    return (
      (this.isIntegratedGridProtection &&
        !!(
          this.generatorGridProtectionDocuments[0]?.documents?.length ||
          this.inverterGridProtectionDocuments[0]?.documents?.length ||
          this.converterGridProtectionDocuments[0]?.documents?.length
        )) ||
      this.isCentralGridProtection
    );
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.detailed_info_grid_power_plant_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.detailed_info_grid_power_plant_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_detailed_info_grid_power_plant_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_detailed_info_grid_power_plant_locked = value;
  }
}
